export const SEARCH_DEBOUNCE_MS = 300;

export const TEST_ID = 'createMixPage';
